export default __webpack_public_path__ + "static/media/conpInfo_banner0627.fa974930.jpg";